// src/pages/Privacidade.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Privacidade = () => {
  return (
    <>
      <div id="section1-pg6">
        <div className="page-content">
          <div className="subsection1-font-pg6">

            <h1>Aviso de privacidade</h1>
            <h2>1. Informações gerais</h2>
            <p>
              O presente Aviso de Privacidade contém informações a respeito do modo como tratamos, 
              total ou parcialmente, de forma automatizada ou não, os dados pessoais dos usuários 
              que acessam nosso aplicativo. Seu objetivo é esclarecer os interessados acerca dos 
              tipos de dados que são coletados, dos motivos da coleta e da forma como o usuário 
              poderá atualizar, gerenciar ou excluir estas informações.
            </p>
            <p>
              Este Aviso de Privacidade foi elaborado visando conformidade com a Lei Federal 
              n. 12.965 de 23 de abril de 2014 (Marco Civil da Internet), com a Lei Federal 
              n. 13.709, de 14 de agosto de 2018 (Lei de Proteção de Dados Pessoais) e, no que 
              for aplicável quanto às atividades de tratamento de dados pessoais e quanto ao 
              nosso negócio, com o Regulamento UE n. 2016/679 de 27 de abril de 2016 (Regulamento 
              Geral Europeu de Proteção de Dados Pessoais - RGDP).
            </p>
            <p>
              Este Aviso de Privacidade poderá ser atualizado em decorrência de eventual 
              atualização normativa ou alterações nas atividades de tratamento, razão pela qual 
              se convida o usuário a consultar periodicamente esta seção.
            </p>

            <h2>2. Dever de não fornecer dados de terceiros</h2>
            <p>
              Durante a utilização do aplicativo, a fim de resguardar e de proteger os direitos 
              de terceiros, o usuário do aplicativo deverá fornecer somente seus dados pessoais, 
              e não os de terceiros, ficando responsável pela exatidão das informações que revelar.
            </p>

            <p><strong>3. Informações coletadas</strong></p>
            <p>
              A coleta de dados dos usuários se dará em conformidade com o disposto neste Aviso 
              de Privacidade para fins de cumprimento da prestação de serviço.
            </p>

            <h3>3.1. Tipos de dados coletados</h3>
            <h4>3.1.1. Dados de identificação do usuário para realização de cadastro</h4>
            <p>
              A utilização, pelo usuário, de determinadas funcionalidades do aplicativo dependerá 
              do cadastro do usuário na instituição de ensino com a qual possui vínculo, sendo que, 
              nestes casos, os seguintes dados do usuário serão coletados e armazenados: nome, data 
              de nascimento, gênero, endereço de e-mail, CEP de residência, números de telefone ou 
              celular, dados de desempenho e frequência acadêmica do usuário referentes ao histórico 
              de matrículas e atividades realizadas pelo usuário em sua instituição de ensino, e 
              dados da situação financeira do usuário relativa ao histórico de pagamentos realizados 
              para com a instituição de ensino com a qual possui vínculo.
            </p>

            <h4>3.1.2. Registros de acesso</h4>
            <p>
              Em atendimento às disposições do art. 15, caput e parágrafos, da Lei Federal 
              n. 12.965/2014 (Marco Civil da Internet), os registros de acesso do usuário serão 
              coletados e armazenados por, pelo menos, seis meses.
            </p>

            <h4>3.1.3. Newsletter</h4>
            <p>
              O endereço de e-mail cadastrado pelo usuário que optar por se inscrever em nossa 
              Newsletter será coletado e armazenado até que o usuário solicite seu descadastro.
            </p>

            <h4>3.1.4. Dados sensíveis</h4>
            <p>O aplicativo não coletará dados sensíveis dos usuários.</p>

            <h4>3.1.5. Coleta de dados não previstos expressamente</h4>
            <p>
              Eventualmente, outros tipos de dados não previstos expressamente neste Aviso 
              de Privacidade poderão ser coletados, desde que sejam fornecidos com o consentimento 
              do usuário, ou, ainda, que a coleta seja permitida ou imposta por lei.
            </p>

            <h3>3.2. Fundamento jurídico para o tratamento dos dados pessoais</h3>
            <p>
              Ao utilizar os serviços do aplicativo, o usuário tomará ciência do presente Aviso 
              de Privacidade.
            </p>
            <p>
              Cada atividade de tratamento realizada pelo app estará respaldada em pelo menos uma 
              hipótese de tratamento de dados pessoais prevista na legislação (bases legais).
            </p>
            <p>
              Caso o usuário queira saber mais sobre as hipóteses autorizadoras das atividades de 
              tratamento de dados pessoais, entre em contato conosco pelo endereço de e-mail 
              app+privacidade@plataformacodi.com.br.
            </p>

            <h3>3.3. Finalidades do tratamento dos dados pessoais</h3>
            <p>
              Os dados pessoais do usuário coletados pelo aplicativo têm por finalidade facilitar, 
              agilizar e cumprir os compromissos estabelecidos com o usuário e a fazer cumprir as 
              solicitações realizadas por meio do preenchimento de formulários.
            </p>
            <p>
              Os dados pessoais poderão ser utilizados também com uma finalidade comercial, para 
              personalizar o conteúdo oferecido ao usuário, bem como para dar subsídio ao aplicativo 
              para a melhora da qualidade e funcionamento de seus serviços.
            </p>
            <p>
              O aplicativo recolhe os dados do usuário para que seja realizada definição de perfis 
              (profiling), ou seja, tratamento automatizado de dados pessoais que consista em utilizar 
              estes dados para avaliar certos aspectos pessoais do usuário, principalmente para analisar 
              ou prever características relacionadas ao seu desempenho profissional, a sua situação 
              econômica, saúde, preferências pessoais, interesses, fiabilidade, comportamento, localização 
              ou deslocamento.
            </p>
            <p>
              Os dados de cadastro serão utilizados para permitir o acesso do usuário a determinados 
              conteúdos do aplicativo, exclusivos para usuários cadastrados.
            </p>
            <p>
              O tratamento de dados pessoais para finalidades não previstas neste Aviso de Privacidade 
              somente ocorrerá mediante comunicação prévia ao usuário, sendo que, em qualquer caso, os 
              direitos e obrigações aqui previstos permanecerão aplicáveis.
            </p>

            <h3>3.4. Prazo de retenção dos dados pessoais</h3>
            <p>
              Os dados pessoais do usuário serão retidos por um período não superior ao exigido para 
              cumprir os objetivos em razão dos quais eles são tratados.
            </p>
            <p>
              O período de retenção dos dados são definidos de acordo com os seguintes critérios:
            </p>
            <p>
              Os dados serão armazenados pelo tempo necessário para a prestação do serviço à instituição 
              de ensino com a qual o usuário possui vínculo, conforme prazo de duração do contrato da 
              instituição de ensino com a plataforma codi.
            </p>
            <p>
              Os dados pessoais dos usuários apenas poderão ser retidos após o término de seu tratamento 
              nas seguintes hipóteses:
            </p>
            <ul>
              <li>para o cumprimento de obrigação legal ou regulatória pelo controlador;</li>
              <li>para estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;</li>
              <li>para a transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos na legislação;</li>
              <li>para uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados.</li>
            </ul>

            <h3>3.5. Destinatários e transferência dos dados pessoais</h3>
            <p>
              Os dados pessoais do usuário poderão ser compartilhados com a instituição de ensino 
              com a qual o usuário possui vínculo. Serão, portanto, tratados apenas por este aplicativo, 
              pela plataforma codi e pela instituição de ensino do usuário.
            </p>

            <h2>4. Do tratamento dos dados pessoais</h2>
            <h3>4.1. Do responsável pelo tratamento dos dados (data controller)</h3>
            <p>
              O controlador, responsável pelo tratamento dos dados pessoais do usuário, é a pessoa 
              física ou jurídica, a autoridade pública, a agência ou outro organismo que, individualmente 
              ou em conjunto com outras, determina as finalidades e os meios de tratamento de dados pessoais.
            </p>
            <p>
              Neste aplicativo, o responsável pelo tratamento dos dados pessoais coletados é 
              JAL Sistemas Educacionais Ltda, representada por André Cruz Mendes, que poderá ser 
              contactado pelo e-mail: app+privacidade@plataformacodi.com.br.
            </p>
            <p>
              O responsável pelo tratamento dos dados se encarregará diretamente do tratamento dos 
              dados pessoais do usuário.
            </p>

            <h2>5. Segurança no tratamento dos dados pessoais do usuário</h2>
            <p>
              O aplicativo se compromete a aplicar as medidas técnicas e organizativas aptas a proteger 
              os dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração, 
              comunicação ou difusão de tais dados.
            </p>
            <p>
              Para a garantia da segurança, serão adotadas soluções que levem em consideração: as técnicas 
              adequadas; os custos de aplicação; a natureza, o âmbito, o contexto e as finalidades do 
              tratamento; e os riscos para os direitos e liberdades do usuário.
            </p>
            <p>
              O aplicativo utiliza certificado SSL (Secure Socket Layer) que garante que os dados pessoais 
              se transmitam de forma segura e confidencial, de maneira que a transmissão dos dados entre o 
              servidor e o usuário, e em retroalimentação, ocorra de maneira totalmente cifrada ou encriptada.
            </p>
            <p>
              A violação de dados pessoais é uma violação de segurança que provoque, de modo acidental ou 
              ilícito, a destruição, a perda, a alteração, a divulgação ou o acesso não autorizados a dados 
              pessoais transmitidos, conservados ou sujeitos a qualquer outro tipo de tratamento.
            </p>

            <h2>6. Dados de navegação (cookies)</h2>
            <p>
              Cookies são pequenos arquivos de texto enviados pelo aplicativo ao computador do usuário e 
              que nele ficam armazenados, com informações relacionadas à navegação do aplicativo.
            </p>
            <p>
              Por meio dos cookies, pequenas quantidades de informação são armazenadas pelo navegador do 
              usuário para que nosso servidor possa lê-las posteriormente. Podem ser armazenados, por exemplo, 
              dados sobre o dispositivo utilizado pelo usuário, bem como seu local e horário de acesso ao aplicativo.
            </p>
            <p>
              Os cookies não permitem que qualquer arquivo ou informação sejam extraídos do disco rígido do usuário, 
              não sendo possível, ainda, que, por meio deles, se tenha acesso a informações pessoais que não tenham 
              partido do usuário ou da forma como utiliza os recursos do aplicativo.
            </p>
            <p>
              É importante ressaltar que nem todo cookie contém informações que permitem a identificação do usuário, 
              sendo que determinados tipos de cookies podem ser empregados simplesmente para que o aplicativo seja 
              carregado corretamente ou para que suas funcionalidades funcionem do modo esperado.
            </p>
            <p>
              As informações eventualmente armazenadas em cookies que permitam identificar um usuário são 
              consideradas dados pessoais. Dessa forma, todas as regras previstas neste Aviso de Privacidade 
              também lhes são aplicáveis.
            </p>

            <h3>6.1. Cookies do aplicativo</h3>
            <p>
              Os cookies do aplicativo são aqueles enviados ao computador ou dispositivo do usuário e 
              administrador exclusivamente pelo aplicativo.
            </p>
            <p>
              As informações coletadas por meio destes cookies são utilizadas para melhorar e personalizar 
              a experiência do usuário, sendo que alguns cookies podem, por exemplo, ser utilizados para 
              lembrar as preferências e escolhas do usuário, bem como para o oferecimento de conteúdo personalizado.
            </p>

            <h3>6.2. Cookies de terceiros</h3>
            <p>
              Alguns de nossos parceiros podem configurer cookies nos dispositivos dos usuário que acessam 
              nosso aplicativo.
            </p>
            <p>
              Estes cookies, em geral, visam possibilitar que nossos parceiros possam oferecer seu conteúdo 
              e seus serviços ao usuário que acessa nosso aplicativo de forma personalizada, por meio da obtenção 
              de dados de navegação extraídos a partir de sua interação com o aplicativo.
            </p>
            <p>
              O usuário poderá obter mais informações sobre os cookies de terceiro e sobre a forma como os 
              dados obtidos a partir dele são tratados, além de ter acesso à descrição dos cookies utilizados 
              e de suas características, acessando o seguinte link:
            </p>
            <p>
              Google Analytics<br />
              - <a
                  href="https://developers.google.com/analytics/devguides/collection/gajs/cookie-usage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                https://developers.google.com/analytics/devguides/collection/gajs/cookie-usage
              </a>
            </p>
            <p>As entidades encarregadas da coleta dos cookies poderão ceder as informações obtidas a terceiros.</p>

            <h3>6.3. Gestão dos cookies e configurações do navegador</h3>
            <p>
              O usuário poderá se opor ao registro de cookies pelo aplicativo, bastando que desative esta 
              opção no seu próprio navegador ou aparelho.
            </p>
            <p>
              A desativação dos cookies, no entanto, pode afetar a disponibilidade de algumas ferramentas 
              e funcionalidades do aplicativo, comprometendo seu correto e esperado funcionamento. Outra 
              consequência possível é a remoção das preferências do usuário que eventualmente tiverem sido 
              salvas, prejudicando sua experiência.
            </p>
            <p>
              A seguir, são disponibilizados alguns links para as páginas de ajuda e suporte dos navegadores 
              mais utilizados, que poderão ser acessadas pelo usuário interessado em obter mais informações 
              sobre a gestão de cookies em seu navegador:
            </p>
            <p>
              Internet Explorer: &nbsp;
              <a
                href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies
              </a>
            </p>
            <p>
              Safari:&nbsp;
              <a
                href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://support.apple.com/pt-br/guide/safari/sfri11471/mac
              </a>
            </p>
            <p>
              Google Chrome: &nbsp;
              <a
                href="https://support.google.com/chrome/answer/95647?hl=pt-BR&amp;hlrm=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://support.google.com/chrome/answer/95647?hl=pt-BR&amp;hlrm=pt
              </a>
            </p>
            <p>
              Mozila Firefox:&nbsp;
              <a
                href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam
              </a>
            </p>
            <p>
              Opera:&nbsp;
              <a
                href="https://www.opera.com/help/tutorials/security/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.opera.com/help/tutorials/security/privacy/
              </a>
            </p>

            <h2>7. Das alterações</h2>
            <p>
              A presente versão deste Aviso de Privacidade foi atualizada pela última vez em: 15/06/2020.
            </p>
            <p>
              Nos reservamos no direito de modificar, a qualquer momento e sem qualquer aviso prévio, o 
              aplicativo às presentes normas, especialmente para adaptá-las às evoluções do aplicativo codi, 
              seja pela disponibilização de novas funcionalidades, seja pela supressão ou modificação 
              daquelas já existentes.
            </p>
            <p>
              Dessa forma, convida-se o usuário a consultar periodicamente esta página para verificar 
              as atualizações.
            </p>

            <h2>8. Do Direito aplicável e do foro</h2>
            <p>
              Para a solução das controvérsias decorrentes do presente instrumento, será aplicado integralmente 
              o Direito brasileiro e demais normas aplicáveis.
            </p>
            <p>
              Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra a instituição 
              de ensino com a qual o usuário possui vínculo e para a qual a plataforma codi presta serviço.
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default Privacidade;
